export function company_title(profile) {
    var description = "";

    profile && profile.Title !== "" && profile.Title !== null ?
        profile.Company !== "" && profile.Company !== null ? 
            description = profile.Title + " at " + profile.Company
        :
            description = profile.Title
    :
        profile && profile.Company !== "" && profile.Company !== null ? 
            description = profile.Company
        :
            description = ""

    return description;
}